import {all, Association} from '@eitje/api'
import {createSelector} from 'reselect'

// USER SELECTORS
export const selfSelector = createSelector(
	state => all(state, 'users'),
	state => state.auth?.user,
	(users, user) => users.find(u => u.id === user?.id) || user,
)

// ORGANISATION SELECTORS
export const currentOrgSelector = createSelector(
	state => state.app?.orgId || state.organisation?.id,
	state => all(state, 'organisations'),
	(orgId, orgs) => {
		if (orgId) return orgs.find(o => o.id == orgId) || {} // For mobile app
		return {} // Just in case
	},
)

const currentOrgIdSelector = createSelector(
	// This selector reconciles the orgId from the mobile app with the orgId from the web app. The problem is
	// that the app, at least for now, has no current/ active env, but a current/ active org instead, so the
	// selector currentOrgSelector won't work.
	currentOrgSelector,
	state => state.app?.orgId,
	(org, mobileOrgId) => mobileOrgId || org?.id,
)

export const currentEnvSelector = createSelector(
	state => all(state, 'environments'),
	currentOrgIdSelector,
	(envs, orgId) => {
		const currentOrgIdEnv = envs.find(e => e.organisation_id === orgId)
		if (currentOrgIdEnv) return currentOrgIdEnv
		return envs[0] || {}
	},
)

export const currentEnvIdSelector = createSelector(currentEnvSelector, env => env?.id)

export const orgEnvsSelector = createSelector(
	currentOrgIdSelector,
	currentEnvSelector,
	state => all(state, 'environments'),
	(orgId, env, envs) => (orgId ? envs.filter(e => e.organisation_id == orgId) : new Association([env]).filter(Boolean)),
)
